import { ref, onMounted, computed } from 'vue'
import API from '@admin/other/API'
import { Chart } from 'chart.js/auto'
import { defineStore } from 'pinia'

// The grand WP Dark Mode Store
export default defineStore('useVisitor', () => {

	const isLocked = ![true, 1, 'true', '1'].includes(wp_dark_mode_admin_json.is_ultimate)

	const reportInterval = ref(1)
	const reportIntervals = {
		1: 'Last 24 Hours',
		7: 'Last 7 Days',
		30: 'Last 30 Days',
		365: 'Last 1 Year',
	}

	const chart = ref(null)
	const ctx = ref(null)
	const visitors = ref([])
	const isDummy = ref(false)

	const labels = computed(() => {
		switch (Number(reportInterval.value)) {
			case 1:
			default:
				return ['12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM',
					'9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM',
					'5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM'
				]
			case 7:
				// Return Sunday, Monday, Tuesday, etc 
				const days = []
				for (let i = 0; i < 7; i++) {
					days.push(new Date(Date.now() - (i * 24 * 60 * 60 * 1000)).toLocaleDateString('en-US', {
						weekday: 'short'
					}))
				}

				return days.reverse()
			case 30:
				// Return 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, etc
				const days30 = []
				for (let i = 0; i < 30; i++) {
					days30.push(new Date(Date.now() - (i * 24 * 60 * 60 * 1000)).getDate())
				}

				return days30.reverse()
			case 365:
				// Return Jan, Feb, Mar, etc
				const months = []
				for (let i = 0; i < 12; i++) {
					months.push(new Date(Date.now() - (i * 30 * 24 * 60 * 60 * 1000)).toLocaleDateString('en-US', {
						month: 'short'
					}))
				}

				return months.reverse()
		}
	})

	const calculateVisitedData = (mode = 'any') => {
		switch (Number(reportInterval.value)) {
			case 1:
			default:
				// Return 00 AM to 23 PM with filtered visitors length in that hour
				const hours = []
				for (let i = 0; i < 24; i++) {
					hours.push( visitors.value ? visitors.value?.filter(visitor => {
						const date = new Date(visitor.created_at)
						return date.getHours() === i && (mode === 'any' || visitor.mode === mode)
					}).length : 0)
				}

				return hours
			case 7:
				// Return Sunday, Monday, Tuesday, etc with filtered visitors length in that day
				const days = []
				for (let i = 0; i < 7; i++) {
					days.push(visitors.value ? visitors.value.filter(visitor => {
						const date = new Date(visitor.created_at)
						return date.getDay() === i && (mode === 'any' || visitor.mode === mode)
					}).length : 0)
				}

				return days

			case 30:
				// Return 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, etc with filtered visitors length in that day
				const days30 = []
				for (let i = 0; i < 30; i++) {
					days30.push(visitors.value ? visitors.value.filter(visitor => {
						const date = new Date(visitor.created_at)
						return date.getDate() === i && (mode === 'any' || visitor.mode === mode)
					}).length : 0)
				}

				return days30

			case 365:
				// Return Jan, Feb, Mar, etc with filtered visitors length in that month
				const months = []
				for (let i = 0; i < 12; i++) {
					months.push(visitors.value ? visitors.value.filter(visitor => {
						const date = new Date(visitor.created_at)
						return date.getMonth() === i && (mode === 'any' || visitor.mode === mode)
					}).length : 0)
				}

				return months
		}
	}

	const allVisitors = computed(() => {
		return calculateVisitedData('any')
	})

	const darkModeUsers = computed(() => {
		return calculateVisitedData('dark')
	})

	const chartData = computed(() => {
		return {
			labels: labels.value,
			datasets: [
				{
					label: 'Dark Mode Users' + ' (' + darkModeUsers.value.reduce((a, b) => a + b, 0) + ')',
					data: darkModeUsers.value,
					fill: false,
					tension: 0.1
				},
				{
					label: 'Total Visitors' + ' (' + visitors.value.length + ')',
					data: allVisitors.value,
					fill: false,
					tension: 0.1
				}]
		}
	})

	const drawChart = () => {
		setTimeout(() => {
			const ctx = document.querySelector('#wp-dark-mode-chart')?.getContext('2d')

			// console.log(chartData.value)
			chart.value = new Chart(ctx, {
				type: 'line',
				data: chartData.value,
			});
		}, 50)
	}

	const updateChart = () => {

		// Destroy chart.value if already exists
		if (chart.value) {
			chart.value.destroy()
		}

		drawChart()
	}

	const loadVisitors = async () => {
		API.get('visitors').then(response => {
			visitors.value = response.data
		}).catch(error => {
			// If error then show dummy data
			isDummy.value = true
		}).finally(() => {
			drawChart()
		})
	}

	onMounted(() => {
		loadVisitors()
	})

	// export all the functions and variables 
	return {
		isLocked,
		reportInterval,
		reportIntervals,
		updateChart,
		loadVisitors
	}
})